import { forwardRef } from "react"

import { useAuth } from "@trueskin-web/context"
import { i18nCurrency } from "@trueskin-web/locales"

import { PAYMENT_METHODS } from "../../payment-methods"

const withTokenization = (Component) =>
  forwardRef(({ onTokenization, className }, ref) => {
    const { user } = useAuth()

    const order = {
      amount: 0,
      amountInCents: 0,
      currency: i18nCurrency(),
      customerId: user._id,
      v2CustomerId: user.v2CustomerId,
      accountId: user.accountId,
    }

    return (
      <Component
        ref={ref}
        className={className}
        hideHeader
        order={order}
        onTokenization={onTokenization}
        hidePaymentMethods={[PAYMENT_METHODS.KLARNA]}
      />
    )
  })

export default withTokenization
